(() => {
  const setup = () => {
    document.querySelectorAll('[data-ryb-gi-options]').forEach(options => {
      const host = options.closest('.shopify-section');
      const page = host?.querySelector('.product-information');
      const grid = page?.querySelector('.product-information__grid');
      const details = grid?.querySelector('.product-details');
      if (!grid || !details) return;
      page.classList.add('ryb-gi-page');
      const guide = host.querySelector('[data-ryb-gi-guide]');
      if (guide && guide.parentElement !== grid) grid.append(guide);
      const description = page.querySelector('.ryb-product-description-under-media');
      if (description) {
        description.classList.add('ryb-gi-description');
        if (description.parentElement !== grid) grid.append(description);
      }
      page.dataset.rybGiReady = 'true';
    });
  };
  setup();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  document.addEventListener('shopify:section:load', setup);
})();
